import { ETypeNotification } from "@app/enums/ETypeNotification";
import { notification } from "@digital/ui";

export const msgTypeNotification = (msg: string, type?: number) => {

    if (!type) {
        type = ETypeNotification.ERROR;
    }

    switch (type) {
        case ETypeNotification.SUCCESS:
            notification.success(msg);
            break;
        case ETypeNotification.WARNING:
            notification.warn(msg);
            break;
        case ETypeNotification.INFO:
            notification.info(msg);
            break;
        case ETypeNotification.ERROR:
            notification.error(msg);
            break;
        case ETypeNotification.ANYTHING:
            return;
    }
}